<template>
  <div>
    <template v-if="value">
      <div class="image-show" :style="{ backgroundImage: `url(${src})`, width: `${w}px`, height: `${h}px`, minWidth: `${this.minWidth}px`, minHeight: `${this.minHeight}px`}">
        <div class="mask d-flex">
          <div class="image-edit d-flex align-items-center justify-content-center" @click="showModal">
            <a-icon type="edit" style="font-size: 15px;" />
          </div>
          <div class="image-delete d-flex align-items-center justify-content-center" @click="handleDelete">
            <a-icon type="delete" style="font-size: 15px;" />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="image-add d-flex justify-content-center align-items-center" @click="showModal">
        <a-icon type="plus-circle" theme="twoTone" style="font-size: 28px;" />
      </div>
    </template>
  </div>
</template>

<script>
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'CompanyInfoImageCropper',
  mixins: [WindowsMixin],
  props: ['value', 'format', 'h', 'w'],
  data () {
    return {
      visible: false,
    }
  },
  computed: {
    src () {
      return `data:${this.format};base64,${this.value}`
    },
    minWidth () {
      if (this.w > this.h) {
        return 100 * this.w / this.h
      }
      return 100
    },
    minHeight () {
      if (this.h > this.w) {
        return 100 * this.h / this.w
      }
      return 100
    },
  },
  methods: {
    showModal () {
      this.createDialog('ImageCropperDialog', {
        ok: (data) => {
          this.$emit('change', data.url)
        },
        previewStyle: {
          width: `${this.w}px`,
          height: `${this.h}px`,
        },
        cropperProps: {
          containerStyle: {
            width: '100%',
            height: '300px',
          },
          viewMode: 1,
          dragMode: 'move',
          cropBoxResizable: false,
          toggleDragModeOnDblclick: false,
          minCropBoxWidth: this.w,
          minCropBoxHeight: this.h,
          minCanvasWidth: this.w,
          ready: (e) => {
            e.target.cropper.setCropBoxData({ width: this.w, height: this.h, top: 0, left: 0 })
          },
        },
      })
    },
    handleDelete () {
      this.$emit('change', '')
    },
  },
}
</script>

<style lang="less" scoped>
.image-show, .image-add {
  position: relative;
  width: 104px;
  height: 104px;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  transition: border-color 0.3s ease;
  overflow: hidden;
  .mask {
    width: 100%;
    height: 30px;
    position: absolute;
    bottom: -30px;
    left: 0;
    transition: all 0.1s ease;
    .image-edit, .image-delete {
      height: 100%;
      width: 50%;
      background: rgba(0,0,0,0.5);
      color: rgba(255,255,255,0.7);
      &:hover {
        background: rgba(0,0,0,0.8);
        color: #fff;
      }
    }
  }
  &:hover {
    border-color: #1890ff;
    .mask {
      bottom: 0;
    }
  }
}
.image-show {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 0 0;
  &:hover {
    border-color: #1890ff;
  }
}
</style>
